/** Centralized validation patterns and input sanitizers. */

export const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;
export const PAN_CARD_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const AADHAR_CARD_REGEX = /^[0-9]{12}$/;
export const IFSC_CODE_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const ACCOUNT_NUMBER_REGEX = /^\d{9,18}$/;
export const ACCOUNT_HOLDER_NAME_REGEX = /^[a-zA-Z\s]+$/;
export const PASSWORD_COMPLEXITY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;
export const PASSWORD_COMPLEXITY_LOOKAHEAD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/;

export const NON_DIGITS_REGEX = /\D/g;
export const NON_ALPHANUMERIC_UPPERCASE_REGEX = /[^A-Z0-9]/g;

export const sanitizeDigits = (value, maxLength) =>
  String(value ?? "")
    .replace(NON_DIGITS_REGEX, "")
    .slice(0, maxLength);

export const sanitizeAadharInput = (value) => sanitizeDigits(value, 12);

export const sanitizePanInput = (value) =>
  String(value ?? "")
    .toUpperCase()
    .replace(NON_ALPHANUMERIC_UPPERCASE_REGEX, "")
    .slice(0, 10);

export const isValidIndianMobile = (value) =>
  INDIAN_MOBILE_REGEX.test(sanitizeDigits(value, 10));

export const isValidPanCard = (value) =>
  PAN_CARD_REGEX.test(sanitizePanInput(value));

export const isValidAadharCard = (value) =>
  AADHAR_CARD_REGEX.test(sanitizeAadharInput(value));

export const isPasswordComplex = (value) =>
  PASSWORD_COMPLEXITY_LOOKAHEAD_REGEX.test(value || "");
